import React from "react"
import GoogleAppLink from "./google-app-link"
import Social from "./social"
import Visual from "./visual"
import { Flex, chakra, Icon } from "@chakra-ui/react"
import {FaTools} from "react-icons/fa";
import {Paragraph} from "../style";

const UnderConstruction = () => {

    return <Flex width="100%" direction={["column-reverse","column-reverse","row","row"]} textAlign="center">
        <Flex flex="1 1 content" direction="column" justifyContent="center" padding="2em" overflow="visible" zIndex={100}>
            <chakra.h2 fontSize="2em"><Icon as={FaTools} /> Under construction</chakra.h2>
            <Paragraph>Currently the site is under construction.</Paragraph>
            <Paragraph>You can listen to the radio through the app.</Paragraph>
            <GoogleAppLink/>
            <Paragraph>Or browse the little content that's currently available on the site.<br/> Expect updates to come over the next coming weeks.</Paragraph>
            <Social />
        </Flex>
        <Visual/>
    </Flex>
};

export default UnderConstruction